
<template>
  <div>
    <IKFiltroFuncionario ref="ikFiltroFuncionario"/>    
    <h6 class="p-text-bold">Período</h6>  
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">            
            <Calendar v-model="dataInicio" view="month" :yearNavigator="true" :yearRange="rangeData" :showIcon="true" 
            :manualInput="false" dateFormat="mm/yy" :locale="localeCalendarBR"/>				
        </div>        
    </div>
    <div class="p-field p-col-12 p-md-12"> 
       <h6 class="p-text-bold">Intervalo. </h6>                           
      <div class="p-field-radiobutton">
        <RadioButton id="menor1hora" name="maiorQueDuasHoras" v-model="maiorQueDuasHoras" :value="false"/>
        <label>Menor que 1 hora.</label>
      </div>
      <div class="p-field-radiobutton">
        <RadioButton id="maior2horas" name="maiorQueDuasHoras" v-model.number="maiorQueDuasHoras" :value="true"/>
        <label>Maior que 2 horas.</label>
      </div>  
    </div> 
    <div class="p-field p-col-12 p-md-6">  
        <h6 class="p-text-bold">Intervalo entre inicio da jornada. </h6>                          
        <div class="p-field-checkbox">
            <Checkbox v-model="maiorQueSeisHoras" :binary="true"/>
            <label>Maior que 6 horas.</label>
        </div>
    </div> 
    <Button label="Gerar PDF" icon="pi pi-file-pdf" class="p-mt-3" @click="exportarPdf"/>
  </div>
</template>

<script>
import RelatorioService from '@/service/RelatorioService';
import IKFiltroFuncionario from '@/components/template/IKFiltroFuncionario';
import { exibirMensagem, exibirMensagemSis, preViewArquivo, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    relatorioService: null,
    data() {
        return {
            maiorQueDuasHoras: false,
            maiorQueSeisHoras: false,
            dataInicio: new Date(),
            rangeData: '',
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        exportarPdf() {
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let requisicao = {               
                mesSelecionado: this.dataInicio.getMonth()+1,
                anoSelecionado: this.dataInicio.getFullYear(),
                maiorQueDuasHoras: this.maiorQueDuasHoras,
                maiorQueSeisHoras: this.maiorQueSeisHoras,
                ativo: dados.ativo,
                cnpj: {...dados.cnpj},
                idsFuncionarios: idsFuncionarios,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.relatorioService.exportarIntervaloAlmoco(requisicao)
            .then(resp => {     
                preViewArquivo(resp.data);             
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });
        },
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
        },
    },
    created() {
        this.relatorioService = new RelatorioService();
    },
    mounted() {
        this.criarRangeData();
    },
    components: {
        'IKFiltroFuncionario': IKFiltroFuncionario,
    }
}
</script>

<style>

</style>